import { render, staticRenderFns } from "./InspectionDetailPromos.vue?vue&type=template&id=66cd2c76&scoped=true&"
import script from "./InspectionDetailPromos.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailPromos.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailPromos.vue?vue&type=style&index=0&id=66cd2c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd2c76",
  null
  
)

export default component.exports